module.exports = __webpack_public_path__ + "media/images/icon-phone-inbound-d5d162384f526ac49a96df8383530bb8.svg";